import { Path } from "@common/constans";
import { IPnrInfo, IPnrInfoRequest } from "@common/models";
import Divider from "@components/general/Divider";
import Button from "@components/general/form/Button";
import Icon from "@components/general/Icon";
import { AppAction, IAppAction } from "@misc/Action";
import { Action, memberPnrInfo } from "@service/proxy";
import Translate from "@service/Translate";
import { formatToDate, getAirport } from "@utilize/Format";
import { FC, Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

interface ICurrentTripsProps {
    pnrInfo: IPnrInfo[];
}

const CurrentTrips: FC<ICurrentTripsProps> = ({ pnrInfo }) => {
    const tr = Translate.tr;
    const dispatch = useDispatch();
    const { push } = useHistory();
    const [pnrInfoLoading, setPnrInfoLoading] = useState<boolean>(false);
    const [index, setIndex] = useState<number>(-1);

    const onPnrInfoClick = (pnrItem: IPnrInfo) => {
        setIndex(pnrInfo.findIndex(p => p.pnr === pnrItem.pnr));
        const pnrInfoRequest: IPnrInfoRequest = {
            pnr: pnrItem.pnr,
            contactLastName: pnrItem.contactPerson?.lastName,
            departureDate: pnrItem.originDestinations?.filter(od => od.visibility)[0].departureDateTime
        };
        setPnrInfoLoading(true);
        memberPnrInfo(Action.POST, { data: pnrInfoRequest })
            .then((response) => {
                const pnrInfo = response.content;
                dispatch<IAppAction>({ type: AppAction.PnrInfo, payload: { pnrInfo: pnrInfo } });
                dispatch<IAppAction>({ type: AppAction.ShowBackButton, payload: { showBackButton: true } });
                push(`${Path.Booking.ManageBooking}?pnr=${pnrItem.pnr}`);
            })
            .catch((err) => { })
            .finally(() => {
                setPnrInfoLoading(false);
            })
    }

    return (
        <div className="current-trips">
            {
                pnrInfo.map(((pnrInfoItem, i) => {
                    const trips = pnrInfoItem.originDestinations?.filter(od => od.visibility);
                    return (
                        <Fragment key={i}>
                            <div className="row flex flex-center current-trips-item">
                                <div className="col-1-4 col-sm-1-auto current-trips-item-cell">
                                    <div className="row spa-2 flex flex-no-wrap flex-center">
                                        {trips?.length === 2 && trips[0].origin.code === trips[1].destination.code && trips[0].destination.code === trips[1].origin.code ? <>
                                            <div className="col-1-auto current-trips-leg-route">
                                                <span className="origin">{getAirport(trips[0].origin.code).cityName}</span>
                                                <Icon name="icon-route" flipRtl />
                                                <span className="destination">{getAirport(trips[0].destination.code).cityName}</span>
                                            </div>
                                            <div className="col-1-auto current-trips-round-trip">{tr('round_trip')}</div>
                                        </>
                                            : trips?.map((t, i) => <div key={i} className="col-1-auto current-trips-leg-route">
                                                <span className="origin">{getAirport(t.origin.code).cityName}</span>
                                                <Icon name="icon-airplane" />
                                                <span className="destination">{getAirport(t.destination.code).cityName}</span>
                                            </div>)}
                                        <div className="current-trips-collapse-gradient" />
                                    </div>
                                </div>
                                <div className="col-1-4 col-sm-1-1 current-trips-item-cell">
                                    <span className="current-trips-item-cell-title">{tr("reservation_number")}: </span>
                                    <span className="current-trips-item-cell-content">{pnrInfoItem.pnr}</span>
                                </div>
                                <div className="col-1-4 col-sm-1-1 current-trips-item-cell">
                                    <span className="current-trips-item-cell-title">{tr("reservation_date")}: </span>
                                    <span className="current-trips-item-cell-content">{pnrInfoItem.bookingDate ? formatToDate(pnrInfoItem.bookingDate) : ""}</span>
                                </div>
                                <div className="col-1-4 col-sm-1-auto current-trips-item-cell flex">
                                    <Button
                                        text={tr("pnr_info")}
                                        variant="outlined"
                                        loading={i === index && pnrInfoLoading}
                                        onClick={() => onPnrInfoClick(pnrInfoItem)}
                                        disabled={!pnrInfoItem.pnr}
                                        height="35px"
                                    />
                                </div>
                            </div>
                            <Divider mode="perforation" orientation="horizontal" />
                        </Fragment>
                    )
                }

                ))
            }
        </div>
    )
}

export default CurrentTrips;